export default __webpack_public_path__ + "static/media/40k.226e868c.md";